<template>
	<div class="user_wrap">
		<div class="red_top_bg">
			<!-- <div class="back_left" @click="$router.back()"></div> -->
			<div class="big_tit">{{ $t('home.my') }}</div>
		</div>
		<div class="top_header">
			<!-- <router-link to="/sign" class="set_go"></router-link> -->
			 <div style="height: 20px;"></div>
			<div class="user_detail">
				<div class="user_header" style="background:#f5f0f0">
					<img src="@/assets/images/mine.png" alt="">
				</div>
				<!-- <div class="user_name">
					<div class="user_all">
						<p class="user_nickname">{{ data.name ? data.name : data.mobile }}</p>
					</div>
				</div> -->
			</div>
			<div class="user_vip">
				<!-- {{ $t('user.welcome') }} -->
				<p>{{ data.mobile ? data.mobile : data.name }}</p>
				<!-- <p style="margin-top: 5px;font-size:14px;">{{ data.vip_name }}</p> -->
			</div>
			<!-- <div class="user_balance" v-if="eye == 1">
				<div>
					{{ $t('moneybag.accountBalance') }}
					<van-icon name="eye-o" @click="eye = 0" />
				</div>
				<div style="display: flex;justify-content: center;">
					<div class="divs" style="width: 45%;text-align: center;">
						{{ $t('utils.moneyMark') }} {{ data.money }}
					</div>
					<div style="width: 10px;"></div>
					<div class="divs" style="width: 45%;text-align: center;">
						USD {{ data.usdt_money }}
					</div>
				</div>
			</div>
			<div class="user_balance" v-if="eye == 0">
				<div>
					{{ $t('moneybag.accountBalance') }}
					<van-icon name="eye-o" @click="eye = 1" />
				</div>
				<div style="display: flex;justify-content: center;">
					<div class="divs" style="width: 45%;text-align: center;">
						{{ $t('utils.moneyMark') }} ***
					</div>
					<div style="width: 10px;"></div>
					<div class="divs" style="width: 45%;text-align: center;">
						USD ***
					</div>
				</div>
			</div> -->
			<!-- <div class="user_money" v-if="eye == 1">
				<div>
					<p>{{ $t('user.uncollectedPrincipal') }}</p>
					<p>+{{ $t('utils.moneyMark') }}{{ data.wait_money }}</p>
				</div>
				<div>
					<p>{{ $t('user.uncollectedInterest') }}</p>
					<p>+{{ $t('utils.moneyMark') }}{{ data.wait_lixi }}</p>
				</div>
				<div>
					<p>{{ $t('user.cumulativeIncome') }}</p>
					<p>+{{ $t('utils.moneyMark') }}{{ data.all_lixi }}</p>
				</div>
			</div>
			<div class="user_money" v-if="eye == 0">
				<div>
					<p>{{ $t('user.uncollectedPrincipal') }}</p>
					<p>******</p>
				</div>
				<div>
					<p>{{ $t('user.uncollectedInterest') }}</p>
					<p>******</p>
				</div>
				<div>
					<p>{{ $t('user.cumulativeIncome') }}</p>
					<p>******</p>
				</div>
			</div> -->
		</div>
		<div class="kong"></div>
		
		<div class="user_yw">
			<div class="user_box">
				<div class="divs">
					<p class="t">{{ $t('wdye') }}</p>
					<div>
						<!-- <div class="b"><span>{{ $t('utils.moneyMark') }}</span> <span>{{data.all_lixi?data.all_lixi:0}}</span></div> -->
						<div class="b"><span>USD</span> <span>{{data.money?data.money:0}}</span></div>
					</div>
				</div>
				<div class="bian"></div>
				<div class="divs">
					<p class="t">{{ $t('累计认购') }}</p>
					<div>
						<!-- <div class="b"><span>{{ $t('utils.moneyMark') }}</span> <span>{{data.total_investment_amount?data.total_investment_amount:0}}</span></div> -->
						<div class="b"><span>USD</span> <span>{{data.usd_total_investment_amount?data.usd_total_investment_amount:0}}</span></div>
					</div>
				</div>
			</div>
			<!-- <div @click="$router.push('/order')">
				<img src="../images/user/order.png" alt="" />
				<p>{{ $t('user.myInvestment') }}</p>
			</div>
			<div @click="$router.push('/moneybag')">
				<img src="../images/user/details.png" alt="" />
				<p>{{ $t('user.transactionDetails') }}</p>
			</div> -->
			<div class="flexs">
				<a @click="$router.push('/invest')">
					<img src="@/assets/images/rk.png" alt="" />
					<p>{{ $t('user.recharge') }}</p>
				</a>
				<a @click="$router.push('/cash')">
					<img src="@/assets/images/tk.png" alt="" />
					<p>{{ $t('user.withdraw') }}</p>
				</a>
				<a :href="kefu_link">
					<img src="../images/user/kf.png" alt="" />
					<p>{{ $t('user.onlineService') }}</p>
				</a>
			</div>
		</div>
		<!-- <div class="money">
			<div>
				<p>{{ $t('user.availableBalance') }}</p>
				<p>{{ $t('utils.moneyMark') }}{{ data.money }}</p>
			</div>
			<div>
				<span @click="$router.push('/invest')">{{ $t('user.recharge') }}</span>
				<span @click="$router.push('/cash')">{{ $t('user.withdraw') }}</span>
			</div>
		</div> -->
		<div style="height: 5px;"></div>
		<div class="list">
			<van-cell is-link @click="$router.push('/moneybag')">
				<template #title>
					<span class="custom-title">{{ $t('user.myWallet') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/idCard')">
				<template #title>
					<span class="custom-title">{{ $t('身份认证') }}</span>
				</template>
			</van-cell>
			<!-- <van-cell is-link @click="$router.push('/ex')">
				<template #title>
					<span class="custom-title">{{ $t('ex.redemption') }}</span>
				</template>
			</van-cell> -->
			<van-cell is-link @click="$router.push('/account')">
				<template #title>
					<span class="custom-title">{{ $t('account.manage') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/rechargeRecord')">
				<template #title>
					<span class="custom-title">{{ $t('user.rechargeRecord') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/withdrawRecord')">
				<template #title>
					<span class="custom-title">{{ $t('user.withdrawalRecord') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/order')">
				<template #title>
					<span class="custom-title">{{ $t('rgxq') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/myTeam')">
				<template #title>
					<span class="custom-title">{{ $t('index.invite') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/loan')">
				<template #title>
					<span class="custom-title">{{ $t('智能融资') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/notice')">
				<template #title>
					<span class="custom-title">{{ $t('notice.message') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/contract')">
				<template #title>
					<span class="custom-title">{{ $t('home.contract') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/language')">
				<template #title>
					<span class="custom-title">{{ $t('safe.language') }}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/safe')">
				<template #title>
					<span class="custom-title">{{ $t('user.setting') }}</span>
				</template>
			</van-cell>
		</div>
		<div class="list" style="margin-top: 0px;">
			<van-cell  @click="logout">
				<div class="out-btn">{{$t('safe.signOut')}}</div>
			</van-cell>
		</div>
		<div style="height:150px"></div>
	</div>
</template>

<script>
import Vue from 'vue';
import qs from 'qs';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index";
import {
	Icon,
	Cell,
	CellGroup,
	Dialog
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon);

export default {
	name: "user",
	components: {
	},
	data() {
		return {
			data: {},
			eye: 1,
			kefu_link:''
		};
	},
	created() {
		this.$parent.footer('user');
		Fetch('/index/webconfig', { type: 'web' }).then(res => {
				this.kefu_link = res.data.kefu_link
				localStorage.setItem('web_name',res.data.web_name)
		})
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			Fetch('/user/info').then((r) => {
				this.data = r.data;
			});
		}, 
		logout() {
				Dialog.confirm({
                    message:this.$t('safe.signOut')+'?',
                    confirmButtonText:this.$t('utils.confirm'),
                    cancelButtonText:this.$t('utils.cancel')
                })
                .then(() => {
                    localStorage.removeItem('token');
					this.$router.replace("/");
                })
                .catch(() => {
                    // on cancel
                });
			
		}
	}
};
</script>

<style lang="less" scoped>
.user_wrap {
	background-color: #FAFAFA;
	max-width: 100%;
	height: fit-content;
	padding-top: 44px;
}
.red_top_bg {
	position: relative;
	position: fixed !important;
	top: 0px;
	z-index: 99;
}
.out-btn {
	width: 220px;
	text-align: center;
	height: fit-content;
	margin:15px auto 10px auto;
	padding: 5px 15px;
	border-radius: 4px;
	background: #f03e3e;
	color: #fff;
}
.user_box {
	width: 100% !important;
	height: 66px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin:0px auto 10px auto;
	.divs {
		width: 49% !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		p {
			font-size: 15px;
		}
		.t {
			font-size: 13px;
		}
		.b {
			font-size: 15px;
			font-weight: bold;
			display: flex;
			padding: 0 10px;
			margin-top: 2px;
			span:nth-child(1) {
				width: 50px;
			}
			span:nth-child(2) {
				width: fit-content;
				text-align: left;
			}
		}
	}
	.bian {
		width: 1px !important;
		height: 76%;
		background: #999;
		padding: 0px;
		margin-top: 8px;
	}
}
.top_header {
	position: relative;
	width: 100%;
	height: 245px;
	background: url('~@/assets/images/bg.jpg') no-repeat center center / 100%;

	.set_go {
		width: 38px;
		height: 38px;
		position: absolute;
		top: 11px;
	}

	.set_go {
		right: 14px;
		background: url(../images/user/sign.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.user_detail {
		width: fit-content;
		padding: 24px 15px 0 15px;
		top: 34px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;

		.user_header {
			width: 50px;
			height: 50px;
			overflow: hidden;
			border-radius: 50%;
			border: 3px solid rgba(255, 255, 255, 0.3);

			img {
				width: 100%;
				height: 100%;
			}
		}

		.user_name {
			margin-left: 3px;
			margin-top: 3px;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			color: #FFFFFF;

			.user_all {
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.user_nickname {
					line-height: 21px;
					font-size: 16px;
					font-weight: bold;
					color: #fff;
					margin-left: 5px;
				}
			}
		}
	}

	.user_vip {
		color: #333;
		font-weight: bold;
		font-size: 18px;
		margin: 10px 20px 0px 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		p {
			text-shadow: 0px 1px 2px #fff;
		}
	}

	.user_balance {
		text-align: center;

		div {
			margin: 5px 0;
		}

		div:nth-child(1) {
			font-size: 14px;
			color: #FFFFFF !important;
			text-shadow: 0 1px 1px #333;
		}

		.divs {
			font-weight: bold !important;
			font-size: 18px !important;
			color: #FFFFFF !important;
			text-shadow: 0 1px 1px #333;
			margin-top: 8px;
		}
	}

	.user_money {
		display: flex;
		justify-content: space-between;
		text-align: center;

		p {
			margin: 8px 0;
		}

		div {
			width: 33.33%;
			padding: 0 6px;
		}

		p:nth-child(1) {
			font-size: 14px;
			color: #d3d5d6;
		}

		p:nth-child(2) {
			font-size: 15px;
			font-weight: bold;
			color: #FFFFFF;
		}
	}
}

.kong {
	width: 100%;
	height: 35px;
	background: #FFFFFF;
}

.user_yw {
	display: flex;
	flex-direction: column;
	text-align: center;
	width: 96%;
	background: #FFFFFF;
	left: 2%;
	border-radius: 5px 5px 0 0;
	padding:0 0 15px 0;
	position: relative;
	margin-top: -112px;
	.flexs {
		width: 100%;
		display: flex;
		align-items: center;
		p {
			color:#333;
			margin-top:5px;
		}
	}
	.t {
		margin-bottom: 2px;
	}
	a {
		display: block;
		width: 33.33%;
		padding: 0 6px;
		text-decoration: none;
	}

	p {
		margin-top: 2px;
	}

	img {
		width: 30px;
		height: 30px;
	}
}

.money {
	display: flex;
	justify-content: space-between;
	width: 96%;
	background: #FFFFFF;
	border-radius: 5px;
	margin-top: -73px;
	margin-left: 2%;
	padding: 15px;

	div:nth-child(1) {
		width: 40%;
		text-align: left;

		p:nth-child(1) {
			color: #999;
			margin-bottom: 10px;
		}

		p:nth-child(2) {
			font-size: 14px;
			font-weight: bold;
		}
	}

	div:nth-child(2) {
		width: 60%;
		text-align: right;
		margin-top: 12px;

		span {
			padding: 5px 10px;
			border-radius: 5px;
			margin: 0 5px;
			color: #fff;
		}

		span:nth-child(1) {
			background: #000;
		}

		span:nth-child(2) {
			background: #5b5a58;
		}
	}
}

.list {
	width: 96%;
	margin-left: 2%;
	margin-top: -10px;
	border-radius: 5px;

	img {
		vertical-align: middle;
		height: 30px;
		width: 30px;
		margin-right: 10px;
	}
}
</style>
